import React from 'react';
import { useTranslation } from 'react-i18next';
import { translationKeys } from '@gik/inkind-page/i18n/en';
import bemBlock from '@gik/core/utils/bemBlock';
import { PropsWithClassName } from '@gik/core/utils/ReactUtils';
import { IGenericCardProps, PrivacySettingsCard } from '@gik/inkind-page';

export const flowersCardBlockName = 'flowers-card';

const FlowersCard: React.FC<PropsWithClassName<IGenericCardProps>> = ({
  className,
  value,
  onChange,
  inputName,
}): JSX.Element => {
  const { t } = useTranslation();
  const bem = bemBlock(flowersCardBlockName);

  return (
    <PrivacySettingsCard
      className={bem(null, null, className)}
      title={t(translationKeys.flowersTitle)}
      icon={{
        set: 'gik-icons',
        name: value ? 'FlowersOkOutline' : 'FlowersDisabledOutline',
      }}
      description={value ? t(translationKeys.flowersDescription) : t(translationKeys.flowersDescriptionDisabled)}
      value={value}
      onChange={onChange}
      inputName={inputName}
    />
  );
};

export default FlowersCard;
